var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckmarkIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkmark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 1.3999L11.8241 1.49779L4.76426 8.55764L2.17589 5.96927L2.11885e-06 5.87138L0.09789 8.04727L2.68626 10.6356L2.68571 10.6362L4.7637 12.7142L4.76426 12.7136L4.7658 12.7152L6.84379 10.6372L6.84226 10.6356L13.9021 3.57579L14 1.3999Z",
    fill: "#1ED760"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckmarkIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/checkmark-icon.944de20a0fc07c3689cc16dda8018672.svg";